exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}#timeclock{top:0;left:0;height:100vh;width:100vw;display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;min-height:30rem}@media (max-width:599px){#timeclock{min-height:20rem}}@media (min-width:1024px){#timeclock{min-height:50rem}}#timeclock .timeclockAnimations{-webkit-box-flex:1;-moz-flex:1;-ms-flex:1;flex:1;overflow-y:auto;background-color:#59636f;height:calc(100% - 9rem)}@media (max-width:599px){#timeclock .timeclockAnimations{height:calc(100% - 6rem)}}@media (min-width:1024px){#timeclock .timeclockAnimations{height:calc(100% - 11rem)}}@-webkit-keyframes flash{0%{opacity:0;z-index:1000;visibility:visible}10%{opacity:1;visibility:visible}to{opacity:0;z-index:0}}@keyframes flash{0%{opacity:0;z-index:1000;visibility:visible}10%{opacity:1;visibility:visible}to{opacity:0;z-index:0}}body{margin:0;overflow-x:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/timeclock/styles.scss
// module id = 1065
// module chunks = 0